import { FC } from 'react';

import { Heading, Link } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { arrowRight } from '@purpur/library/icon/assets/arrow-right';

import { PlainLink } from '@telialt/common-plain-link/src';

import { CtaProvider } from '../CtaProvider/CtaProvider';
import { BlockHeaderContainer } from './Common.styles';
import { CtaData } from './model';

type Props = {
    title?: string;
    cta?: CtaData;
    isNegative?: boolean;
};

export const BlockHeader: FC<Props> = ({ title, cta, isNegative }) => {
    if (!title && !cta) {
        return null;
    }

    return (
        <BlockHeaderContainer $isReversed={!title}>
            {title && (
                <Heading variant="title-300" tag="h2" negative={isNegative}>
                    {title}
                </Heading>
            )}
            {cta && (
                <CtaProvider cta={cta}>
                    {({ href, target, rel, text, onClick }) =>
                        href ? (
                            <Link
                                variant="standalone"
                                href={href}
                                onClick={onClick}
                                target={target}
                                negative={isNegative}
                                rel={rel}
                                disableVisited={true}
                                data-element="Link"
                                data-element-name={text}
                                data-element-type="Section Heading Link"
                            >
                                {text}
                                <Icon svg={arrowRight} size="xs" />
                            </Link>
                        ) : (
                            <PlainLink
                                onClick={onClick}
                                styledAsLink={true}
                                withPadding={true}
                                size="sm"
                                negative={isNegative}
                                data-element="Link"
                                data-element-name={text}
                                data-element-type="Section Heading Link"
                            >
                                {text}
                                <Icon svg={arrowRight} size="xs" />
                            </PlainLink>
                        )
                    }
                </CtaProvider>
            )}
        </BlockHeaderContainer>
    );
};
